export var CONTAINER_CLASS = "CONTAINER_CLASS";
export var CONTAINER_BEFORE = "CONTAINER_BEFORE";
export var CONTAINER_BEGIN = "CONTAINER_BEGIN";
export var CONTAINER_TRIVIA_BEGIN = "CONTAINER_TRIVIA_BEGIN";
export var CONTAINER_END = "CONTAINER_END";
export var CONTAINER_AFTER = "CONTAINER_AFTER";

// TODO: We shouldn't need these in a webiny world
export var CONTENT_BEGIN = "CONTENT_BEGIN";
export var CONTENT_BEFORE_IMAGE = "CONTENT_BEFORE_IMAGE";
export var CONTENT_AFTER_IMAGE = "CONTENT_AFTER_IMAGE";
export var CONTENT_RELATIVE_IMAGE = "CONTENT_RELATIVE_IMAGE";
export var CONTENT_BEFORE_HEADLINE = "CONTENT_BEFORE_HEADLINE";
export var CONTENT_AFTER_HEADLINE = "CONTENT_AFTER_HEADLINE";
export var CONTENT_BEFORE_BUTTON = "CONTENT_BEFORE_BUTTON";
export var CONTENT_AFTER_BUTTON = "CONTENT_AFTER_BUTTON";
export var CONTENT_END = "CONTENT_END";
export var WIDGET_CLASS = "WIDGET_CLASS";
//# sourceMappingURL=positions.js.map